import React from "react";
import "./Laboratorio.css";

const LaboratorioTxt = () => {
    return (
        <React.Fragment>
            <div className="ptur-laboratorio-textoFinal">
                <span className="rb14l">Recuerde que si tiene una orden para más de una determinación, puede tomar un <b>turno de laboratorio general</b></span>
            </div>
        </React.Fragment>
    );
}
 
export default LaboratorioTxt;